/* ==========================================================================
   EZION — CART
   Line quantity changes and removals go through /cart/change.js and the
   page re-renders itself from the response, so the shopper never waits on
   a full reload to see a total move.
   ========================================================================== */

(function () {
  'use strict';

  var EZ = window.EZION || (window.EZION = {});

  class EzCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));

      var note = this.querySelector('[data-cart-note]');
      if (note) {
        note.addEventListener('change', function () {
          fetch(EZ.routes.cart_update + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).catch(function () {});
        });
      }
    }

    onChange(event) {
      var input = event.target.closest('[data-line-qty]');
      if (!input) return;
      var line = input.closest('[data-line]');
      this.change(line, parseInt(input.value, 10) || 0);
    }

    onClick(event) {
      var remove = event.target.closest('[data-line-remove]');
      if (!remove) return;
      event.preventDefault();
      this.change(remove.closest('[data-line]'), 0);
    }

    change(line, quantity) {
      if (!line) return;
      line.setAttribute('data-busy', '');

      fetch(EZ.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.key, quantity: quantity })
      })
        .then(function (response) {
          return response.json().then(function (cart) {
            if (!response.ok) throw new Error(cart.description || cart.message || EZ.strings.error);
            return cart;
          });
        })
        .then(function (cart) {
          EZ.setCartCount(cart.item_count);

          // An empty cart changes the whole layout, so let the server render it.
          if (cart.item_count === 0) {
            window.location.reload();
            return;
          }

          if (quantity === 0) {
            line.remove();
          } else {
            var item = cart.items.find(function (i) { return i.key === line.dataset.key; });
            if (item) {
              line.querySelector('[data-line-qty]').value = item.quantity;
              line.querySelector('.ez-line__total').textContent = EZ.formatMoney(item.final_line_price);
            }
          }

          var subtotal = document.querySelector('[data-cart-subtotal]');
          var total = document.querySelector('[data-cart-total]');
          if (subtotal) subtotal.textContent = EZ.formatMoney(cart.items_subtotal_price);
          if (total) total.textContent = EZ.formatMoney(cart.total_price);
        })
        .catch(function (error) {
          EZ.toast(error.message || EZ.strings.error, null);
        })
        .then(function () {
          line.removeAttribute('data-busy');
        });
    }
  }

  if (!customElements.get('ez-cart')) customElements.define('ez-cart', EzCart);
})();
